import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Table,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap"

//Import Component
import Breadcrumbs from "components/Common/Breadcrumb"
import axios from "axios"
import ReportsTable from "./ReportsTable"
import UnAuthorizedComponent from "common/UnAuthorizedComponent"
import { Tab, Tabs } from "react-bootstrap"
import TicketsTable from "./TicketsTable"
import InfoTable from "./InfoTable"
import FinancialTable from "./FinancialTable"
import Drive from "./Drive/Drive"
import StatusUpdates from "./StatusUpdates"
import { useHistory } from "react-router-dom"
import UpdateOutsidePagesLinksModal from "./UpdateOutsidePagesLinksModal"

const ProjectDetails = props => {
  const history = useHistory()
  const ProjectID = props.match.params?.ProjectID

  const [projectData, setProjectData] = useState()

  const [projectPagesLink, setProjectsPagesLinks] = useState(false)
  const [projectPagesLinkType, setProjectsPagesLinkType] = useState(null)
  const projectPagesLinkToggle = () => {
    setProjectsPagesLinks(projectPagesLink => !projectPagesLink)
  }

  const [designerInfo, setDesignerInfo] = useState(false)
  const toggleDesignerInfo = () => {
    setDesignerInfo(!designerInfo)
  }

  // console.log("projectData", projectData)
  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ProjectID: ProjectID,
    }
    axios
      .post(process.env.REACT_APP_API_URL + "api/PDinfo.php", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        if (res.data.error === false) {
          // console.log("res=================", res.data)
          let array = Object.values(res.data)
          array.splice(-1)
          // console.log("array =================", array)
          setProjectData(array[0])
        }
      })
      .catch(err => console.log("error------>", err))
  }, [])

  // **************** Authorization ******************************
  const [auth, setAuth] = useState(false)
  const designerInfoRef = useRef(null)

  // Access denied !!
  if (auth) {
    return <UnAuthorizedComponent />
  }

  return (
    <div className="page-content">
      <Container fluid>
        {/* Render Breadcrumbs */}
        <Breadcrumbs title="Projects" breadcrumbItem="Project Details" />

        {projectData && (
          <>
            <Table className="project-list-table table-nowrap text-center align-middle table-borderless">
              <thead>
                <tr>
                  <th>Ref No.</th>
                  <th>Req No.</th>
                  <th>Areal Decision No.</th>
                  <th>Project Name</th>
                  <th>Owner</th>
                  <th>Payment Status</th>
                  <th>Region</th>
                  <th>Last Stage</th>
                  <th>Next Stage</th>
                  <th>Visits No</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span id="referenceNo">
                      {projectData.ReferenceNo}
                      <UncontrolledTooltip
                        placement="bottom"
                        target="referenceNo"
                      >
                        {projectData.PolicyNo}
                      </UncontrolledTooltip>
                    </span>
                  </td>
                  <td>{projectData.RequestID}</td>
                  <td>{projectData.ArealDecisionNumber}</td>
                  <td>{projectData.ProjectName}</td>
                  <td>{projectData.OwnerName}</td>
                  <td>
                    {" "}
                    <span
                      className={
                        projectData.Paid === "1"
                          ? "badge bg-success"
                          : projectData.Paid === "0"
                          ? "badge bg-danger"
                          : ""
                      }
                    >
                      {projectData.Paid === "1"
                        ? "Paid"
                        : projectData.Paid === "0"
                        ? "Not Paid"
                        : ""}
                    </span>
                  </td>
                  <td>{projectData.CityNameEN}</td>
                  <td>{projectData.LastStage}</td>
                  <td>{projectData.NextStage}</td>
                  <td>{projectData.VCount}</td>
                </tr>
              </tbody>
            </Table>

            <div className="text-end">
              <>
                <Button
                  size="sm"
                  className="me-2"
                  onClick={() => {
                    toggleDesignerInfo()
                  }}
                  disabled={!projectData.designOffice_name}
                >
                  Designer info
                </Button>
                {designerInfo && (
                  <div className="designer-info">
                    {/* Your designer info content goes here */}
                    <FormGroup className="d-flex">
                      <Label className="col-4 me-2 text-start" for="officeName">
                        Designer Office Name:
                      </Label>
                      <Input
                        type="text"
                        id="officeName"
                        defaultValue={projectData.designOffice_name}
                        disabled
                      />
                    </FormGroup>
                    <FormGroup className="d-flex">
                      <Label for="phoneNo" className="col-4 me-2 text-start">
                        Designer Phone No.:
                      </Label>
                      <Input
                        type="text"
                        id="phoneNo"
                        defaultValue={projectData.designOffice_number}
                        disabled
                      />
                    </FormGroup>
                    <FormGroup className="d-flex">
                      <Label for="email" className="col-4 me-2 text-start">
                        Designer Email:
                      </Label>
                      <p>
                        <a
                          href={`mailto:${projectData.designOffice_email}`}
                          style={{ textDecoration: "none", color: "#007bff" }}
                        >
                          {projectData.designOffice_email}
                        </a>
                      </p>
                    </FormGroup>
                    <Button onClick={toggleDesignerInfo}>close</Button>
                  </div>
                )}
              </>
              {/* <a
                disabled={!projectData?.ticket_link}
                href={projectData.ticket_link}
                target="_blank"
                rel="noopener noreferrer"
                className="me-2"
              >
                <Button
                  disabled={!projectData?.ticket_link}
                  color="primary text-underline"
                  size="sm"
                >
                  Ticket Link
                </Button>
              </a> */}
              {/* <a
                disabled={!projectData.missing_link}
                href={projectData.missing_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  disabled={!projectData?.missing_link}
                  color="primary text-underline"
                  size="sm"
                >
                  Missing Data Link
                </Button>
              </a> */}

              <UncontrolledDropdown
                className="btn-group bg-primary me-2"
                disabled={!projectData.ticket_link}
              >
                <button
                  onClick={() => window.open(projectData.ticket_link, "_blank")}
                  className="btn btn-primary btn-sm dropdown-toggle"
                  disabled={!projectData.ticket_link}
                >
                  Ticket Link
                </button>
                <DropdownToggle
                  tag="a"
                  to="#"
                  className="card-drop"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  disabled={!projectData.ticket_link}
                >
                  <i className="mdi mdi-dots-horizontal font-size-18 text-light me-1"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem
                    onClick={() => {
                      setProjectsPagesLinkType("T")
                      projectPagesLinkToggle()
                    }}
                  >
                    Update Tickets Page Link
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown className="btn-group bg-primary me-2">
                <button
                  onClick={() =>
                    window.open(projectData.missing_link, "_blank")
                  }
                  className="btn btn-primary btn-sm dropdown-toggle"
                  disabled={!projectData.missing_link}
                >
                  Missing Data Link
                </button>
                <DropdownToggle
                  tag="a"
                  to="#"
                  className="card-drop"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  disabled={!projectData.missing_link}
                >
                  <i className="mdi mdi-dots-horizontal font-size-18 text-light me-1"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem
                    onClick={() => {
                      setProjectsPagesLinkType("M")
                      projectPagesLinkToggle()
                    }}
                  >
                    Update Missing Data Link
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>

            {/*************************Tabs section************************************/}

            <div className="mt-5">
              <Tabs className="mb-3" justify fill>
                <Tab eventKey="status" title="Status Updates">
                  <StatusUpdates
                    RequestID={projectData?.RequestID}
                    setAuth={setAuth}
                  />
                </Tab>
                <Tab eventKey="reports" title="Reports">
                  <ReportsTable ProjectID={ProjectID} setAuth={setAuth} />
                </Tab>
                <Tab eventKey="tickets" title="Tickets">
                  <TicketsTable ProjectID={ProjectID} setAuth={setAuth} />
                </Tab>
                <Tab eventKey="info" title="Info">
                  <InfoTable ProjectID={ProjectID} setAuth={setAuth} />
                </Tab>
                <Tab eventKey="drive" title="Drive">
                  <Drive
                    projectData={projectData}
                    ProjectID={ProjectID}
                    setAuth={setAuth}
                  />
                </Tab>
                <Tab eventKey="financial" title="Financial">
                  <FinancialTable ProjectID={ProjectID} setAuth={setAuth} />
                </Tab>
                <Tab eventKey="contact" title="Contact">
                  Contact
                </Tab>
              </Tabs>
            </div>
          </>
        )}

        {projectPagesLink && (
          <UpdateOutsidePagesLinksModal
            projectPagesLinkToggle={projectPagesLinkToggle}
            projectPagesLinkType={projectPagesLinkType}
            ProjectID={ProjectID}
            setAuth={setAuth}
          />
        )}
      </Container>
    </div>
  )
}

export default ProjectDetails
